import { render, staticRenderFns } from "./PartenaireDetail.vue?vue&type=template&id=61de92a2&"
import script from "./PartenaireDetail.vue?vue&type=script&lang=js&"
export * from "./PartenaireDetail.vue?vue&type=script&lang=js&"
import style0 from "./PartenaireDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports